'use client';

import { type FC } from 'react';
import { TabFilter } from '../../../ui';
import type { RushMidTab } from '../RushMidGame';
import { useLocalTranslation } from '../../../../hooks/useLocalTranslation';
import translations from '../RushMid.translations';

interface RushMidTabsProps {
  activeTab: RushMidTab;
  onChange: (tab: RushMidTab) => void;
}

/** The games/fighter/history/rating tab filter shown at the top of every Rush Mid screen.
 *  Carries its OWN data-sound so a tap plays the same звонкий click on every screen —
 *  without the marker it inherited the wrapping screen's variant (ring in the lobby,
 *  the default menu-select on history/rating), so the same tab bar rang differently. */
export const RushMidTabs: FC<RushMidTabsProps> = ({ activeTab, onChange }) => {
  const { t } = useLocalTranslation(translations);
  return (
    <div data-sound="ring">
      <TabFilter
        tabs={[{ id: 'games', label: t('gamesTab') }, { id: 'fighter', label: t('tabFighter') }, { id: 'history', label: t('history') }, { id: 'rating', label: t('ratingTab') }, { id: 'raffle', label: t('raffleTab') }]}
        activeTab={activeTab}
        onChange={onChange}
      />
    </div>
  );
};
